import { useMutation } from '@tanstack/react-query';

import { AcceptUserInfo } from 'model/AcceptUserInfo';
import { OrderEquip } from 'model/Order';
import { YN_TYPE } from 'types/enumType';

import client from './client';
import { BaseResp, LotoActionListResp, LotoBoxListResp, LotoLogListResp, LotoLogResp, LotoPermissionListResp, LotoPermissionLogListResp, LotoSettingListResp, LotoSettingResp, PermissionRegisterResp, TagListResp, TagResp } from './response';
import { LotoLogSearchRequest } from './searchRequest/LotoLogSearchRequest';
import { LotoPermissionSearchRequest } from './searchRequest/LotoPermissionSearchRequest';
import { LotoSettingRequest } from './searchRequest/LotoSettingRequest';
import { LotoSettingSearchRequest } from './searchRequest/LotoSettingSearchRequest';

export const getLotoSettingList = (
  req: LotoSettingSearchRequest,
): Promise<LotoSettingListResp> =>
  client.get('v1/loto/settings', { params: req });
const editLotoSetting = (req: LotoSettingRequest): Promise<BaseResp> =>
  client.post('v1/loto/setting', { ...req });
export const useEditLotoSettingMutation = () => useMutation(editLotoSetting);

// TODO getLotoSetting, registerLotoSetting, updateLotoSetting
export const getLotoSetting = (orderId: number): Promise<LotoSettingResp> => client.get(`v2/loto/setting/${orderId}`);

const updateLotoSetting = (formData: LotoSettingFormData): Promise<BaseResp> => client.post('v2/loto/setting', { ...formData, equips: JSON.stringify(formData.equips) })


export const useUpdateLotoSetting = () => useMutation(updateLotoSetting);

export const getLotoBoxList = (
  req: LotoSettingSearchRequest,
): Promise<LotoBoxListResp> => client.get('v1/loto/approve', { params: req });

type AttachLotoReq = {
  lotoId: number;
  attachUserId?: string;
  attachUserRole?: string;
}

const editLotoBox = (req: AttachLotoReq): Promise<BaseResp> =>
  client.post(`v1/loto/${req.lotoId}/approve`, { ...req });
export const useEditLotoBoxMutation = () => useMutation(editLotoBox);

export const getLotoLogList = (
  req: LotoLogSearchRequest,
): Promise<LotoLogListResp> => client.get('v1/loto/registers', { params: req });
export const getLotoLog = (id: number): Promise<LotoLogResp> =>
  client.get(`v1/loto/${id}`);


const attachLotoLog = (logId: number): Promise<BaseResp> =>
  client.post(`v1/loto/${logId}/lock`);
export const useAttachLotoLogMutation = () => useMutation(attachLotoLog);

const registerLotoLogMemo = (req: LotoLogMemoRequest): Promise<BaseResp> =>
  client.post(`v1/loto/${req.logId}/memo`, { ...req });
export const useRegisterLotoLogMemoMutation = () =>
  useMutation(registerLotoLogMemo);

const deleteLotoLog = (id: number): Promise<BaseResp> =>
  client.post(`v1/loto/${id}/unlock`);
export const useDeleteLotoLogMutation = () => useMutation(deleteLotoLog);

export const getLotoPermissionList = (
  req: LotoPermissionSearchRequest,
): Promise<LotoPermissionListResp> =>
  client.get('v1/loto/orders', { params: req });

const registerPermission = (
  permission: PermissionFormData,
): Promise<PermissionRegisterResp> => client.post('v1/loto/order', { ...permission });
export const useRegisterPermission = () => useMutation(registerPermission);

const toggleLotoSettingYn = (req: lotoSettingYnRequest): Promise<BaseResp> =>
  client.post(`v1/loto/order/${req.orderId}`, { ...req });
export const useToggleLotoSettingYn = () => useMutation(toggleLotoSettingYn);

export const getLotoActionList = (
  orderId: number,
  searchKey: string,
): Promise<LotoActionListResp> =>
  client.get(`v1/loto/order/${orderId}/actions`, { params: { searchKey } });

export const getLotoPermissionLogList = (
  req: LotoPermissionSearchRequest,
): Promise<LotoPermissionLogListResp> =>
  client.get('v1/loto/order/log', { params: req });

const forcedUnlock = (req: forcedUnlockRequest): Promise<BaseResp> =>
  client.post(`v1/loto/${req.lotoId}/locker/${req.lockerId}/unlock`, {
    ...req,
  });
export const useForcedUnlockMutation = () => useMutation(forcedUnlock);

export const getTagList = (req: LotoSettingSearchRequest): Promise<TagListResp> => client.get('v1/tag/list', { params: req });
export const getTag = (tagId: number): Promise<TagResp> => client.get(`v1/tag/${tagId}`);

export interface TagRegisterReq {
  orderId: number;
  equipId: number;
}

const registerTag = (req: TagRegisterReq): Promise<BaseResp> => client.post('v1/tag', req);
export const useRegisterTagMutation = () => useMutation({ mutationFn: registerTag });

const deleteTag = (tagId: number): Promise<BaseResp> => client.delete(`v1/tag/${tagId}`);
export const useDeleteTagMutation = () => useMutation({ mutationFn: deleteTag });


export interface lotoSettingYnRequest extends AcceptUserInfo {
  orderId: number;
  lotoYn: YN_TYPE;
}

export type LotoLogMemoRequest = {
  logId: number;
  fieldMemo: string;
};

export type forcedUnlockRequest = {
  lotoId: number;
  lockerId: number;
};

// export const downloadConclusionListExcel = (req: SearchRequest): Promise<void> => downloadExcel(req, 'v1/conclusion/excel');

export interface PermissionFormData {
  factoryId: string;
  equipName: string;
  name: string;
  detail: string;
  workDate: string;
  lotoYn: string;
  selfWorkYn: YN_TYPE;
  coopUserId?: number;
  acceptUserId?: string,
  acceptUserRole?: string
  // coopWorker?: string;
}

export interface LotoSettingFormData {
  orderId: number;
  equips: OrderEquip[];
  acceptUserId?: string,
  acceptUserRole?: string
}

// 허가서 이전
const permissionTransfer = (
  req: PermissionTransferRequest,
): Promise<BaseResp> =>
  client.post(`v1/loto/order/${req.orderId}/transfer`, { ...req });
export const usePermissionTransfer = () => useMutation(permissionTransfer);

export type PermissionTransferRequest = {
  orderId: number;
  newOrderId: number;
};
